<template>
  <AppCard design="new" padding="none" class="cancellation-card">
    <header class="cancellation-card__header">
      <h3>{{ title }}</h3>
      <slot name="actions" />
    </header>
    <div class="cancellation-card__body">
      <slot />
    </div>
  </AppCard>
</template>

<script>
import AppCard from '@/components/AppCard'

export default {
  name: 'SafariCancellationSectionCard',
  components: { AppCard },
  props: { title: { type: String, required: true } }
}
</script>

<style scoped lang="scss">
.cancellation-card {
  min-width: 0;

  &__header {
    display: flex;
    min-height: 52px;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: $ui-space-8 $ui-space-12;
    padding: $ui-space-8 $ui-space-16;
    border-bottom: 1px solid $ui-line;
    box-sizing: border-box;

    h3 {
      margin: 0;
      color: $ui-ink;
      font: 600 $ui-font-size-section-title / 22px $ui-font-heading;
    }
  }

  &__body {
    min-width: 0;
    padding: $ui-space-12 $ui-space-16;
  }
}
</style>
